import { useState } from 'react';
import * as Sentry from '@sentry/nextjs';

/**
 * @deprecated
 */
const useLocalStorage = (key, initialValue) => {
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const hasWindow = typeof window !== 'undefined';
            const item = hasWindow && window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (err) {
            Sentry.captureException(err);
            // eslint-disable-next-line no-console
            console.log(err);
            return initialValue;
        }
    });

    const setValue = value => {
        try {
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (err) {
            Sentry.captureException(err);
            // eslint-disable-next-line no-console
            console.log(err);
        }
    };

    return [storedValue, setValue];
};

export default useLocalStorage;
